import lng from '@lightningjs/core';
import { Colors, Lightning, Router, Storage, Utils } from '@lightningjs/sdk';
import { addWatchList, likeMovie, removeWatchlist, unlikeMovie } from '../../../api/movies';
import { removeWatchlistSeries, addWatchListSeries } from '../../../api/series/index';
import { store } from '../../../utils/globalData';
export default class MovieInfo extends Lightning.Component {
  static _template() {
    return {
      Item: {
        Image: {},
      },
      Wrapper: {
        MovieLink: {
          text: {
            fontSize: 35,
          },
        },
        ResumeProgress: {
          Progress: {},
        },
        TextBorder: {
          collision: true,
        },
        Icon: {},
      },
    };
  }
  set id(val) {
    return (this._id = val);
  }
  set watchList(val) {
    return (this._watchList = val);
  }
  set movieInfo(val) {
    return (this._movieInfo = val);
  }
  set movieId(val) {
    return (this._movieId = val);
  }
  set index(val) {
    return (this._index = val);
  }
  get movieInfo() {
    return this._movieInfo;
  }
  set movieLink(val) {
    return (this._movieLink = val);
  }
  get movieLink() {
    return this._movieLink;
  }
  get _TextBorder() {
    return this.tag('TextBorder');
  }
  get _Icon() {
    return this.tag('Icon');
  }
  get _MovieLink() {
    return this.tag('MovieLink');
  }
  get _Image() {
    return this.tag('Item.Image');
  }
  getFocus() {
    return this._TextBorder;
  }
  _focus() {
    super._focus();
    this._TextBorder.patch({
      texture: lng.Tools.getRoundRect(
        this._movieLink.width,
        70,
        13,
        5,
        Colors('#02AC25').get(),
        false
      ),
    });
    this.fireAncestors('$changeMovieInfo', {
      title: this._movieInfo.title,
      description: this._movieInfo.description,
      cover: this._movieInfo.screenshot,
      category: this._movieInfo.tags,
      duration: this._movieInfo.duration,
      rating: this._movieInfo.imdb.rating === null ? '−' : this._movieInfo.imdb.rating.avg,
      votes: this._movieInfo.imdb.rating === null ? '−' : this._movieInfo.imdb.rating.num_votes,
      liked: this._movieInfo.liked === null ? '' : this._movieInfo.liked,
      contentRating: this._movieInfo.content_rating,
      isLocked: this._movieInfo.tvod,
    });
  }
  _unfocus() {
    super._unfocus();
    this._TextBorder.patch({
      texture:
        this._movieLink.id > 3
          ? lng.Tools.getRoundRect(this._movieLink.width, 70, 13, 5, Colors('#FFFFFF').get(), false)
          : lng.Tools.getRoundRect(
              this._movieLink.width,
              70,
              13,
              5,
              Colors('#000000').get(),
              false
            ),
    });
  }

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }
  _convertToSeconds(duration) {
    let hours;
    let minutes;
    let seconds;
    const timeParts = duration.split(':');
    if (timeParts.length === 3) {
      hours = parseInt(timeParts[0]);
      minutes = parseInt(timeParts[1]);
      seconds = parseInt(timeParts[2]);
    }
    if (timeParts.length === 2) {
      hours = parseInt('00');
      minutes = parseInt(timeParts[0]);
      seconds = parseInt(timeParts[1]);
    }
    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
      throw new Error('Invalid duration format. Hours, minutes, and seconds must be numbers.');
    }
    return hours * 3600 + minutes * 60 + seconds;
  }
  _initialValue() {
    switch (this._movieLink.id) {
      case 0:
        let percentageCompleted =
          (this._movieInfo.resume_time / this._convertToSeconds(this._movieInfo.duration)) * 100;
        this.tag('ResumeProgress').patch({
          w: 165,
          h: 7,
          x: 300,
          y: 37,
          rect: true,
          zIndex: 1,
          color: Colors('#D6D6D6').get(),
        });
        this.tag('Progress').patch({
          w: (percentageCompleted / 100) * 165,
          h: 7,
          rect: true,
          color: Colors('#FB3A67').get(),
          zIndex: 10,
        });
      case 3:
        return this._watchList != 0
          ? this._watchList
            ? Colors('#02AC25').get()
            : Colors('#FFFFFF').get()
          : this._movieInfo.on_watchlist
          ? Colors('#02AC25').get()
          : Colors('#FFFFFF').get();
      case 4:
        return this._movieInfo.liked
          ? Colors('#02AC25').get()
          : (this.movieInfo.liked == null || this.movieInfo.liked == false) &&
              Colors('#FFFFFF').get();
      case 5:
        return this._movieInfo.liked == false
          ? Colors('#02AC25').get()
          : (this.movieInfo.liked == null || this.movieInfo.liked == true) &&
              Colors('#FFFFFF').get();
      default:
        return Colors('#FFFFFF').get();
    }
  }
  _firstEnable() {
    this._MovieLink.patch({
      text: this._movieLink.title,
      color: this._initialValue(),
      x: 90,
      y: 16,
    });
    this._Icon.patch({
      x: this._movieLink.id > 3 ? 90 : 30,
      y: 21,
      w: 35,
      h: 35,
      texture: lng.Tools.getSvgTexture(Utils.asset(this._movieLink.image), 41, 41),
      color: this._initialValue(),
    });
    this._TextBorder.patch({
      texture:
        this._movieLink.id > 3
          ? lng.Tools.getRoundRect(this._movieLink.width, 70, 13, 5, Colors('#FFFFFF').get(), false)
          : lng.Tools.getRoundRect(
              this._movieLink.width,
              70,
              13,
              5,
              Colors('#000000').get(),
              false
            ),
    });
    this._Image.patch({
      rtt: true,
      zIndex: 2,
      w: this.w,
      h: this.h,
      texture: {
        type: lng.textures.ImageTexture,
        src: this._src,
        resizeMode: { type: 'cover', w: this.w, h: this.h },
      },
    });
  }
  _likeOrDislike() {
    const movieItems = this.parent.children;
    movieItems.forEach((item) => {
      const icon = item.tag('Icon');
      if (item === this && (this._movieLink.id === 4 || this._movieLink.id === 5)) {
        // Define the color that should be applied if this item is clicked
        let targetColor =
          this._movieLink.id === 4 ? Colors('#02AC25').get() : Colors('#02AC25').get();
        // If the item is already the target color, set it to white; otherwise, apply the target color
        let color = icon.color === targetColor ? Colors('#FFFFFF').get() : targetColor;
        icon.patch({
          color: color,
        });
        if (this._movieLink.id === 4) {
          likeMovie(this._movieInfo.id);
        } else if (this._movieLink.id === 5) {
          unlikeMovie(this._movieInfo.id);
        }
      } else if (this._movieLink.id === 4 || this._movieLink.id === 5) {
        // Set white color for other like/dislike items
        icon.patch({
          color: Colors('#FFFFFF').get(),
        });
      }
    });
  }
  _changeValue() {
    let contentPreferences = Storage.get('content_preferences');
    let profileId = Storage.get('profileId');
    let defaultValue = Storage.get(`audiosubtitles-${profileId}`);
    let movieId = this._movieId;
    let movieInfo = this._movieInfo;
    let movieConfiguration = contentPreferences?.find(
      (preference) => preference.profileId === profileId && preference.movieId === movieId
    );
    let profileInfo = Storage.get('profileInfo');
    let subtitle = 'none';
    let audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
    let credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;

    // movieLink.id - id button-a
    switch (this.movieLink.id) {
      case 0:
        // Check if the movie is locked
        if (this._movieInfo.locked) {
          this.fireAncestors('$showPaidTitleModal');
          return;
        }
        // Update audio and credits_start_at based on default values
        if (defaultValue) {
          if (movieInfo.languages[defaultValue.audio]?.hls_stream_url) {
            audio = movieInfo.languages[defaultValue.audio].hls_stream_url;
            credits_start_at = movieInfo.languages[defaultValue.audio].credits_start_at;
          }
          if (movieInfo.languages[defaultValue.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[defaultValue.subtitle].subtitles_file;
          }
        }

        // Update audio and subtitle based on movie configuration
        if (movieConfiguration) {
          subtitle = 'none';
          audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[defaultValue.audio].credits_start_at;

          if (movieInfo.languages[movieConfiguration.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[movieConfiguration.subtitle].subtitles_file;
          }
          audio = movieInfo.languages[movieConfiguration.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[movieConfiguration.audio].credits_start_at;
        }

        // Check if TVOD is not purchased
        if (this._movieInfo.tvod && !this._movieInfo.purchased) {
          return true;
        } else {
          const routes = Router.getHistory();
          const lastRouteHash = routes[routes.length - 1].hash;

          // Regular expression to check if hash starts with "series/"
          const seriesPattern = /^series\/\d+/; // assuming ID is numeric, adjust \d+ if necessary

          // Define common parameters
          const commonParams = {
            currentTime: movieInfo.resume_time,
            subtitle: subtitle,
            videoUrl: audio,
            videoDuration: movieInfo.duration,
            introEndsAt: movieInfo.languages[defaultValue.audio].intro_ends_at,
            movieId: this._movieInfo.id,
            movieInfo: this._movieInfo,
            credits_start_at: credits_start_at,
          };

          // Determine the kind based on the lastRouteHash pattern
          const kind = seriesPattern.test(lastRouteHash) ? 'series' : 'movie';

          // Navigate to player with common parameters
          if (profileInfo.autoplay) {
            Router.navigate(`player/${this._movieInfo.id}`, { ...commonParams, kind });
          } else {
            Router.navigate('player', { kind: 'all', ...commonParams });
          }
        }
        break;
      case 1:
        if (this._movieInfo.locked) {
          this.fireAncestors('$showPaidTitleModal');
          return;
        }

        if (defaultValue) {
          if (movieInfo.languages[defaultValue.audio]?.hls_stream_url) {
            audio = movieInfo.languages[defaultValue.audio].hls_stream_url;
            credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
          }
          if (movieInfo.languages[defaultValue.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[defaultValue.subtitle].subtitles_file;
          }
        }
        if (movieConfiguration) {
          subtitle = 'none';
          audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
          if (movieInfo.languages[movieConfiguration.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[movieConfiguration.subtitle].subtitles_file;
          }
          audio = movieInfo.languages[movieConfiguration.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[movieConfiguration.audio]?.credits_start_at;
        }
        if (this._movieInfo.tvod && !this._movieInfo.purchased) {
          localStorage.removeItem('VODList');
          Router.navigate('player', {
            kind: 'all',
            currentTime: 0,
            subtitle: subtitle,
            videoUrl: this._movieInfo.trailer_hls_stream_url,
            videoDuration: movieInfo.duration,
            introEndsAt: movieInfo.languages[defaultValue.audio].intro_ends_at,
            movieId: this._movieInfo.id,
            movieInfo: this._movieInfo,
            credits_start_at: null,
          });
        } else {
          // Prepare the common parameters for navigation
          const commonParams = {
            currentTime: 0,
            subtitle: subtitle,
            videoUrl: audio,
            videoDuration: movieInfo.duration,
            introEndsAt: movieInfo.languages[defaultValue.audio].intro_ends_at,
            movieId: this._movieInfo.id,
            movieInfo: this._movieInfo,
            credits_start_at: credits_start_at,
          };

          // Determine the kind based on autoplay and the last route hash
          let kind = 'all'; // Default to 'all'
          if (profileInfo.autoplay) {
            const routes = Router.getHistory();
            const lastRouteHash = routes[routes.length - 1].hash;

            // Regular expression to check if hash starts with "series/"
            const seriesPattern = /^series\/\d+/; // assuming ID is numeric, adjust \d+ if necessary

            // Set kind based on whether the last hash matches the series pattern
            kind = seriesPattern.test(lastRouteHash) ? 'series' : 'movie';
          }

          // Navigate to player with the determined kind and common parameters
          Router.navigate(`player/${this._movieInfo.id}`, { kind, ...commonParams });
        }
        break;
      case 2:
        if (this._movieInfo.tvod && !this._movieInfo.purchased) {
          Router.navigate('locked');
        } else {
          Router.navigate(`movie/${this.movieInfo.id}/audio-subtitles`);
        }
        break;
      case 3:
        if (this._movieInfo.tvod && !this._movieInfo.purchased) {
          Router.navigate('locked');
        } else {
          if (this._watchList === 0) {
            let moviesInfo = Storage.get('video');
            const isMovieInWatchlist = this._MovieLink.text.text === 'Added from My List';

            const updateWatchlist = isMovieInWatchlist
              ? removeWatchlist(this._movieInfo.id)
              : addWatchList(this._movieInfo.id);

            const newColor = isMovieInWatchlist ? Colors('#FFFFFF').get() : Colors('#02AC25').get();
            const newText = isMovieInWatchlist ? 'Add to My List' : 'Added from My List';

            updateWatchlist.then(() => {
              store.setMyListFlag(false);
              // Update UI elements and Storage in one step
              Promise.all([
                this._MovieLink.patch({ color: newColor, text: { text: newText } }),
                this._Icon.patch({ color: newColor }),
                Storage.set('video', { ...moviesInfo, watchList: 0 }),
              ]);
            });
          }

          if (this._watchList === true || this._watchList === false) {
            store.setMyListFlag(false);
            let episodesInfo = Storage.get('video');
            this._MovieLink.text.text == 'Added from My List'
              ? removeWatchlistSeries(episodesInfo.id).then(() => {
                  this._MovieLink.patch({
                    color: Colors('#FFFFFF').get(),
                    text: { text: 'Add to My List' },
                  });
                  this._Icon.patch({
                    color: Colors('#FFFFFF').get(),
                  });
                  Storage.set('video', { ...episodesInfo, watchList: false });
                })
              : addWatchListSeries(episodesInfo.id).then(() => {
                  this._MovieLink.patch({
                    color: Colors('#02AC25').get(),
                    text: { text: 'Added from My List' },
                  });
                  this._Icon.patch({
                    color: Colors('#02AC25').get(),
                  });
                  Storage.set('video', { ...episodesInfo, watchList: true });
                });
          }
        }
    }
  }
  _handleEnter() {
    this._likeOrDislike();
    this._changeValue();
  }
}
